import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Button, message } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as Copy } from "assets/icons/copy.svg";

import Otp from "components/otp";

const Index = ({
  loadingOTP,
  sendingOTP,
  digitalSign,
  optData,
  otpError,
  otpSuccess,
  onCloseContract,
  onFinishContract,
  onSendOTP,
}) => {
  const { t } = useTranslation();

  const otpFormRef = useRef();
  const [otpValue, setOtpValue] = useState("");
  const [messageApi, contextHolder] = message.useMessage();

  const profile = useSelector((state) => state?.profileReducer?.userData);
  const pmaOnboarding = useSelector((state) => state?.pmaReducer?.onboarding);

  const handleValuesChange = (changedValues) => {
    setOtpValue(changedValues.otp);
  };

  const handleCopyMsg = () => {
    return messageApi.open({
      type: "success",
      content: t("coppied"),
      className: "body-14px-medium",
    });
  };

  const copyTextToClipboard = async (value) => {
    if ("clipboard" in navigator) {
      handleCopyMsg();
      return await navigator.clipboard.writeText(value);
    }
  };

  const renderOTPSuccess = () => (
    <>
      {contextHolder}
      <div className="p-5">
        <div className="w-32 h-32  table m-auto mb-8 mt-12">
          <div className="w-32 h-32 relative flex justify-center items-center">
            <img
              alt=""
              className="w-32"
              src={"https://cdn.firouzeh.com/public/sign-contract.png"}
            />
          </div>
        </div>
        <div className={`text-center h-18px-medium text-primary-1 mb-6`}>
          {t("pma-onboarding.contract-successful")}
        </div>
        <div className="flex flex-col gap-4 display-demibold bg-white shadow-lg rounded-lg px-4 py-5  ">
          <div className="flex justify-between items-center ">
            <div className="body-14px-regular text-gray-0">{t("about")}</div>
            <div className="flex gap-2">
              <span className="body-14px-demibold text-gray-4">
                {`${t("pma-onboarding.investing-portfolio")} ${
                  pmaOnboarding?.name
                }`}
              </span>
              {pmaOnboarding?.logo && (
                <img
                  src={pmaOnboarding?.logo}
                  alt={pmaOnboarding?.name}
                  className="w-6 h-6 rounded"
                />
              )}
            </div>
          </div>
          <div className="border-t-gray--7 border-dotted border-t "></div>
          <div className=" text-gray-0 bg-gray--9 p-2 flex justify-end items-center  rounded-lg gap-2">
            <span className="body-14px-regular">{digitalSign ?? ""}</span>
            <Copy
              className="cursor-pointer"
              onClick={() => copyTextToClipboard(digitalSign)}
            />
          </div>
        </div>
      </div>
      <div className="py-5 fixed  border-t bg-white border-gray--7 bottom-0  w-full shadow-footer sm:shadow-none max-w-2xl">
        <div className="px-5">
          <Button
            block
            className="default-button-large justify-center"
            onClick={onCloseContract}
          >
            {t("close")}
          </Button>
        </div>
      </div>
    </>
  );
  return otpSuccess ? (
    renderOTPSuccess()
  ) : (
    <div div className="p-5 contract-opt">
      <div className="w-32 h-32  table m-auto mt-5">
        <div className="w-32 h-32 relative flex justify-center items-center">
          <img
            alt=""
            className="w-32"
            src={"https://cdn.firouzeh.com/public/reading-contract.png"}
          />
        </div>
      </div>
      <Otp
        btnLoading={sendingOTP}
        data={{
          receiver: profile?.mobile,
          ...optData?.result,
        }}
        disabled={`${otpValue}`.length < 5}
        formRef={otpFormRef}
        loading={loadingOTP}
        numInputsOtp={5}
        onFinish={onFinishContract}
        onResend={onSendOTP}
        onValuesChange={handleValuesChange}
      />
      {otpError && (
        <div className="body-16px-medium text-error-0 text-center pt-6">
          {otpError}
        </div>
      )}
    </div>
  );
};

export default Index;
